<template>
  <button
    class="box-preview-toolbar-button"
    :class="activeButton(device)"
    @click="updateDevice(device);">
    <i :class="'kp-panel-' + icons[device]"></i>
    <span>{{ device }}</span>
  </button>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

const html = document.querySelector('html');

export default {
  props: {
    device: String,
  },
  data() {
    return {
      icons: {
        desktop: 'pc',
        tablet: 'tablet',
        smartphone: 'mobile',
      },
    };
  },
  mounted() {
    html.setAttribute('data-preview-device', this.canvasPreviewDevice);
  },
  computed: mapGetters({
    canvasPreviewDevice: 'canvasPreviewDevice',
  }),
  methods: {
    ...mapActions([
      'canvasChangePreviewDevice',
      'canvasDisableHighlight',
      'sidebarChangePanel',
    ]),
    activeButton(device) {
      return {
        active: this.canvasPreviewDevice === device,
      };
    },
    updateDevice(device) {
      html.setAttribute('data-preview-device', device);
      this.canvasChangePreviewDevice(device);
      this.canvasDisableHighlight();
      this.sidebarChangePanel('style');
    },
  },
};
</script>



/** WEBPACK FOOTER **
 ** DeviceButton.vue?78fc1ecb
 **/